import { OutboundMessageType, websocket } from '@playcastdotio/Messaging';
import { sendMessage } from '../realtime';

export const requestQuotaLimits = () => {
  const message = websocket.generators.outbound(OutboundMessageType.OUTBOUND_LIMITS, {});
  sendMessage(message);
};

export const sendSms = (inviteId: string, phone: string, message: string) => {
  const outboundMessage = websocket.generators.outbound(OutboundMessageType.OUTBOUND_SMS, {
    inviteId,
    phone,
    message,
  });
  sendMessage(outboundMessage);
};

export const sendEmail = (inviteId: string, email: string, message?: string) => {
  const outboundMessage = websocket.generators.outbound(OutboundMessageType.OUTBOUND_EMAIL, {
    inviteId,
    email,
    message,
  });
  sendMessage(outboundMessage);
};

export const sendBeaconSms = (shareCode: string, phone: string, message: string) => {
  const outboundMessage = websocket.generators.outbound(OutboundMessageType.OUTBOUND_SMS, {
    shareCode,
    phone,
    message,
  });
  sendMessage(outboundMessage);
};

export const sendBeaconEmail = (shareCode: string, email: string, message?: string) => {
  const outboundMessage = websocket.generators.outbound(OutboundMessageType.OUTBOUND_EMAIL, {
    shareCode,
    email,
    message,
  });
  sendMessage(outboundMessage);
};
